// extracted by mini-css-extract-plugin
module.exports = {"root":"_47e774","infoCircleContainer":"_a29632"};